/**
 * modal
 */

import $ from 'jquery';
import VanillaModal from 'vanilla-modal';
import Page from '~/page/page';
import Set from '~/set/set';
import Header from '~/header/header';

export default class Modal extends Page {
  init() {
    this.modal = new VanillaModal({
      modal: '.modal',
      modalInner: '.modal__inner',
      modalContent: '.modal__content',
      loadClass: 'modal-init',
      onClose: () => {
        this.onTransition().then(() => {
          if (!this.isOpen()) {
            this.afterClose();
          }
        });
      }
    });

    this.elements({
      title: '.js-modal-title',
      header: '.js-modal-header',
      content: '.js-modal-content'
    });

    this.$.modal = $('.js-default-modal');
  }
  events() {
    this.$.document.on('click', '[data-modal-close]', () => this.close());
    this.$.document.on('click', '[data-modal]', e => this.handler(e));
  }
  handler(e) {
    e.preventDefault();

    const $target = $(e.currentTarget);
    const name = $target.data('modal');

    if (name.indexOf('/') === -1) {
      const modalId = `#modal-${name}`;

      this.title = $(modalId).data('title') || null;
      this.open(modalId);
    } else {
      const url = $target.attr('href');

      this.loadContent(url)
        .then(() => {
          this.open('#modal');
        })
        .fail(err => {
          throw new Error(err);
        });
    }
  }
  loadContent(url) {
    return $.ajax(url).then(({ title = null, content }) => {
      this.title = title;
      this.setContent(content);
    });
  }
  setContent(content) {
    this.$.modal.html(content);

    const $content = this.$.modal;

    this.setInited = Page.initComponent(Set, $content);

    if (this.setInited) {
      this.$.root.addClass('is-set');
    }
  }
  setTitle(title) {
    if (title) {
      this.$.header.show();
      this.$.title.text(title);
    } else {
      this.$.header.hide();
    }
  }
  open(id) {
    if (this.isOpen()) {
      this.close().then(() => {
        this.beforeOpen();
        this.modal.open(id);
      });
    } else {
      this.beforeOpen();
      this.modal.open(id);
    }
  }
  close() {
    return new Promise(resolve => {
      setTimeout(() => {
        this.modal.close();
        return this.onTransition().then(() => {
          if (!this.isOpen()) {
            this.afterClose();
          }
          resolve();
        });
      }, 400);
    });
  }
  beforeOpen() {
    const scrollbarWidth = this.getScrollbarWidth();
    this.$.body.css({ paddingRight: scrollbarWidth });
    this.setTitle(this.title);

    if (Header.isFixed()) {
      Header.setPadding(scrollbarWidth);
    }
  }
  afterClose() {
    this.$.body.css({ paddingRight: 0 });

    if (this.setInited) {
      this.$.root.removeClass('is-set');
    }

    if (Header.isFixed()) {
      Header.removePadding();
    }
  }
  onTransition() {
    return new Promise(resolve => {
      this.$.root.one('transitionend', () => {
        resolve();
      });
    });
  }
  isOpen() {
    return this.modal.isOpen;
  }
}

Page.mount(Modal, '.js-modal');
